import React from "react";
import { FaInstagram } from "react-icons/fa";
export const Instagramicon = ({ className }) => {
  return (
    <FaInstagram
      alt="whatsapp"
      className={className}
      //   style={{
      //     fontSize: "65px",
      //     position: "fixed",
      //     right: "6.5%",
      //     bottom: "15%",
      //     zIndex: "11",
      //   }}
    />
  );
};
